/* Add p_appEntKey for required columns changes Jan 31, 2024 */
/* Add Bug fix for readonly, required columns Apr 26, 2025 */
/* GUI Changes May 15, 2026 */
<template lang="pug">
	div(class="kt-address d-flex flex-wrap" :class="p_readOnly ? 'read-only':''")
			div(class="form-group col-12")
				label Street Address
				b-form-input(class="styled-input" size="sm" :id="p_appEntKey + '_streetAddress'" v-model="p_recData.streetAddress" :disabled="m_readOnly('streetAddress')" )
			div(class="form-group col-12")
				label City
				b-form-input(class="styled-input" size="sm" :id="p_appEntKey + '_city'" v-model="p_recData.city" :disabled="m_readOnly('city')")
			div(class="form-group col-7")
				label State or Province
				b-form-input(class="styled-input" size="sm" :id="p_appEntKey + '_stateProvince'" v-model="p_recData.stateProvince" :disabled="m_readOnly('stateProvince')")
			div(class="form-group col-5")
				label Zip Code
				b-form-input(class="styled-input" size="sm" :id="p_appEntKey + '_zipCode'" v-model="p_recData.zipCode" :disabled="m_readOnly('zipCode')")
</template>

<script>
import {refData, api_baseURL,userSettings} from "@/utils/ref-data.js";
export default {
	name: "kt-address",
	components: {},
	created() {},
	mounted() {
		var usrOpts = userSettings.userOptions;
		var readOnlyColumns=usrOpts['tableReadOnlyColumns'];
		var requiredColumns=usrOpts['tableRequiredColumns'];
		if(readOnlyColumns) this.d_readOnlyColumns=readOnlyColumns['kt-table-'+this.p_appEntKey]||[];
		if(requiredColumns) this.d_requiredColumns=requiredColumns['kt-table-'+this.p_appEntKey]||[];
		this.d_requiredFields=this.d_requiredColumns.map(c=>{return c.field;});
	},
	data() {
		return {
			d_uid: this._uid,
			d_readOnlyColumns:[],
			d_requiredColumns:[],
			d_requiredFields:[],
			
		};
	},
	props: {
		p_recData: Object,
		p_readOnly: Boolean,
		p_appEntKey: String,
	},
	computed: {
	},
	methods: {
		m_readOnly(col){return (this.d_readOnlyColumns&&this.d_readOnlyColumns.includes(col))?true:false;},
		m_required(col){return (this.d_requiredFields&&this.d_requiredFields.includes(col))?true:false;},
	},
	watch: {
	}
};

</script>

<style lang="less">
.kt-address {
	border: solid 0.1em #e9ecef;
	border-radius: 0.25rem;
	padding: 0 0.1em 0.5em 0.1em;

	.form-group {
		margin-bottom: 0em;
		padding: 0 1em;
		label {
			font-size: 0.8em;
		}
	}
}
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  //1px solid black;
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;    //1px solid #428bca;
  box-shadow: none;
}
input {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid black;
}
input:disabled{
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
input:focus{
  border-color: transparent;
  border-bottom: 1px solid #ddd;   //1px solid #428bca;
  box-shadow: none;
}
</style>